(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Page type detection
      if (window.location.pathname === '/' || request.page_type === 'index') {
        this.header.classList.add('homepage');
      } else {
        this.header.classList.add('non-homepage');
      }

      // Drawer detection
      this.setupDrawerListener();
      this.startDrawerCheck();
    }

    setupDrawerListener() {
      const menuToggle = document.querySelector('.header__icon--menu');
      if (menuToggle) {
        menuToggle.addEventListener('click', () => {
          setTimeout(() => {
            this.checkDrawerState();
          }, 500);
        });
      }
    }

    startDrawerCheck() {
      this.checkDrawerState(); // Initial check
      this.drawerCheckInterval = setInterval(() => {
        this.checkDrawerState();
      }, 500); // Check every 500ms
    }

    checkDrawerState() {
      const drawer = document.querySelector('.menu-drawer-container.menu-opening');
      if (drawer) {
        this.header.classList.add('drawer-active');
      } else {
        this.header.classList.remove('drawer-active');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.drawerCheckInterval) {
        clearInterval(this.drawerCheckInterval);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.header.classList.contains('drawer-active')) {
        if (scrollTop > 0) {
          this.header.classList.add('scrolled');
        } else {
          this.header.classList.remove('scrolled');
        }
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
